export const ENVIRONMENT =
  import.meta.env.VITE_APP_ENVIRONMENT || 'development';
export const SENTRY_DSN = import.meta.env.VITE_APP_SENTRY_DSN;
export const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;
export const USE_SANDBOX = import.meta.env.VITE_APP_USE_SANDBOX;
export const ROOT_DOMAIN = import.meta.env.VITE_ROOT_DOMAIN;
export const PR_NUMBER = import.meta.env.VITE_APP_PR_NUMBER;
export const STRIPE_PUBLISHABLE_KEY = import.meta.env
  .VITE_STRIPE_PUBLISHABLE_KEY;
export const AMPLITUDE_API_KEY = import.meta.env.VITE_APP_AMPLITUDE_API_KEY;
export const AMPLITUDE_ENVIRONMENT = {
  environment: ENVIRONMENT,
  apiKey: AMPLITUDE_API_KEY,
};
